module.exports = __webpack_public_path__ + "a5d7aa1f1a56a8c28ef9c6b2b9e67300.svg";